// src/components/logistique/bus/apiBus.js
// Appels de l'administration vers /api/logistique/transport (jeton employé) :
// les bus scolaires du module Logistique (lot 3b). Même lecture des refus que
// apiLogistique.js : un refus du serveur s'affiche tel qu'il l'a écrit.

import { getAuthHeaders } from '../../../services/api';

const RACINE = '/api/logistique/transport';

const LICENCE_FERMEE = "Les bus scolaires ne sont pas inclus dans la licence de cet établissement.";
const NON_INSTALLE = "Les bus scolaires ne sont pas encore installés dans cet établissement.";

function erreurDuServeur(reponse, donnees, defaut) {
  let message = donnees?.message;
  if (!message && donnees?.code === 'FEATURE_NOT_LICENSED') message = LICENCE_FERMEE;
  if (!message && (reponse.status === 503 || (reponse.status === 404 && !donnees))) message = NON_INSTALLE;
  const erreur = new Error(message || donnees?.error || defaut);
  erreur.code = donnees?.code;
  erreur.statut = reponse.status;
  return erreur;
}

async function appeler(chemin, { methode = 'GET', corps } = {}) {
  let reponse;
  try {
    reponse = await fetch(`${RACINE}${chemin}`, {
      method: methode,
      headers: getAuthHeaders(),
      body: corps !== undefined ? JSON.stringify(corps) : undefined
    });
  } catch {
    throw new Error('Connexion au serveur impossible. Vérifiez la connexion et réessayez.');
  }
  let donnees = null;
  try { donnees = await reponse.json(); } catch { donnees = null; }
  if (!reponse.ok) throw erreurDuServeur(reponse, donnees, 'Une erreur est survenue.');
  return donnees?.data;
}

/** Un PDF : la réponse brute, ou l'erreur JSON du serveur. */
async function telecharger(chemin, { methode = 'GET', corps } = {}) {
  let reponse;
  try {
    reponse = await fetch(`${RACINE}${chemin}`, {
      method: methode,
      headers: getAuthHeaders(),
      body: corps !== undefined ? JSON.stringify(corps) : undefined
    });
  } catch {
    throw new Error('Connexion au serveur impossible. Vérifiez la connexion et réessayez.');
  }
  if (!reponse.ok) {
    let donnees = null;
    try { donnees = await reponse.json(); } catch { donnees = null; }
    throw erreurDuServeur(reponse, donnees, 'Le fichier n\'a pas pu être obtenu.');
  }
  return reponse.blob();
}

const enRequete = (filtres = {}) => {
  const p = new URLSearchParams();
  Object.entries(filtres).forEach(([cle, valeur]) => {
    if (valeur !== undefined && valeur !== null && valeur !== '') p.set(cle, valeur);
  });
  const texte = p.toString();
  return texte ? `?${texte}` : '';
};

const id = (x) => encodeURIComponent(x);

export const bus = {
  referentiels: () => appeler('/referentiels'),
  parametrage: () => appeler('/parametrage'),
  enregistrerParametrage: (reglages) => appeler('/parametrage', { methode: 'PUT', corps: reglages }),
  vehicules: () => appeler('/vehicules'),
  creerVehicule: (v) => appeler('/vehicules', { methode: 'POST', corps: v }),
  modifierVehicule: (vid, v) => appeler(`/vehicules/${id(vid)}`, { methode: 'PUT', corps: v }),
  activerVehicule: (vid, actif) => appeler(`/vehicules/${id(vid)}/actif`, { methode: 'PUT', corps: { actif } }),
  circuits: () => appeler('/circuits'),
  circuit: (cid) => appeler(`/circuits/${id(cid)}`),
  creerCircuit: (c) => appeler('/circuits', { methode: 'POST', corps: c }),
  modifierCircuit: (cid, c) => appeler(`/circuits/${id(cid)}`, { methode: 'PUT', corps: c }),
  activerCircuit: (cid, actif) => appeler(`/circuits/${id(cid)}/actif`, { methode: 'PUT', corps: { actif } }),
  feuilleDeRoute: (cid) => telecharger(`/circuits/${id(cid)}/feuille-de-route`),
  creerArret: (cid, a) => appeler(`/circuits/${id(cid)}/arrets`, { methode: 'POST', corps: a }),
  modifierArret: (aid, a) => appeler(`/arrets/${id(aid)}`, { methode: 'PUT', corps: a }),
  deplacerArret: (aid, sens) => appeler(`/arrets/${id(aid)}/deplacer`, { methode: 'POST', corps: { sens } }),
  activerArret: (aid, actif) => appeler(`/arrets/${id(aid)}/actif`, { methode: 'PUT', corps: { actif } }),
  eleves: (filtres) => appeler(`/eleves${enRequete(filtres)}`),
  affecter: (eid, a) => appeler(`/eleves/${id(eid)}/affectation`, { methode: 'PUT', corps: a }),
  cartes: (demande) => telecharger('/cartes', { methode: 'POST', corps: demande })
};

export const FORMULES = { aller_retour: 'Au mois', aller: 'Au mois, matin seul', retour: 'Au mois, soir seul' };
export const formule = (e) => (e.regime === 'ponctuel' ? 'Au ticket' : (FORMULES[e.sens] || 'Au mois'));
